module.exports = __webpack_public_path__ + "img/search-mobile-2020.f2a68e4b.jpg";